// import React, { useEffect, useState } from 'react';
// import '../css/reviewuser.css';
// import { getWithTokenAPI } from '../../utils/Api'; 

// const ReviewList = () => {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filteredUserId, setFilteredUserId] = useState(null);

//   const fetchReviews = async (userId = null) => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       let url = "/review/find-all";
//       if (userId) {
//         url += `?user_id=${userId}`;
//       }

//       const res = await getWithTokenAPI(token, url);

//       console.log("Fetched reviews for userId:", userId, res.data.reviews);

//       if (res?.data?.reviews) {
//         let data = res.data.reviews;

//         // Optional frontend fallback filtering
//         if (userId) {
//           data = data.filter(r => r.user_id?._id === userId);
//         }

//         setReviews(data);
//       } else {
//         setReviews([]);
//       }
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//       setReviews([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReviews();
//   }, []);

//   const handleUserClick = (userId) => {
//     setFilteredUserId(userId);
//     fetchReviews(userId);
//   };

//   const handleResetFilter = () => {
//     setFilteredUserId(null);
//     fetchReviews();
//   };

//   return (
//   <div className="container mt-4">
// <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
//   <h2 className="text-success fs-2 ff-poppins m-0">User Reviews !!</h2>
//   {filteredUserId && (
//     <button className="btn btn-secondary" onClick={handleResetFilter}>
//       Show All Reviews
//     </button>
//   )}
// </div>


//   {loading ? (
//     <p className="text-center">Loading reviews...</p>
//   ) : reviews.length === 0 ? (
//     <p className="text-center">No reviews found.</p>
//   ) : (
//     <div className="row mt-4">
//       {reviews.map((item) => (
//         <div className="col-md-6 col-lg-4 mb-4" key={item._id}>
//           <div className="card h-100 shadow-sm">
//             <div className="card-body">
//               <h5 className="card-title text-black">{item.product_id?.name || 'N/A'}</h5>
//               <p className="card-text mb-1">
//                 <strong>User:</strong>{' '}
//                 <button
//                   className="btn btn-link p-0"
//                   onClick={() => handleUserClick(item.user_id._id)}
//                   disabled={filteredUserId === item.user_id._id}
//                 >
//                   {item.user_id?.name || 'N/A'}
//                 </button>
//               </p>
//               <p className="card-text mb-1">
//                 <strong>Role:</strong> {item.user_id?.role || 'N/A'}
//               </p>
//               <p className="card-text mb-1">
//                 <strong>Rating:</strong> {item.rating}
//               </p>
//               <p className="card-text mb-2">
//                 <strong>Review:</strong> {item.review}
//               </p>
//               {item.user_id?.profile_image?.url ? (
//                 <img
//                   src={item.user_id.profile_image.url}
//                   alt="Profile"
//                   className="rounded-circle mt-2"
//                   style={{ width: '60px', height: '60px', objectFit: 'cover' }}
//                 />
//               ) : (
//                 <p className="text-muted">No Profile Image</p>
//               )}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   )}
// </div>

//   );
// };

// export default ReviewList;


import React, { useEffect, useState } from 'react';
import '../css/reviewuser.css';
import { getWithTokenAPI } from '../../utils/Api'; 

const ReviewList = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredUserId, setFilteredUserId] = useState(null);

  const fetchReviews = async (userId = null) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      let url = "/review/find-all";
      if (userId) {
        url += `?user_id=${userId}`;
      }

      const res = await getWithTokenAPI(token, url);

      console.log("Fetched reviews for userId:", userId, res.data.reviews);

      if (res?.data?.reviews) {
        let data = res.data.reviews;

        // Optional frontend fallback filtering (if backend filtering isn't perfect)
        if (userId) {
          data = data.filter(r => r.user_id?._id === userId);
        }

        setReviews(data);
      } else {
        setReviews([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const handleUserClick = (userId) => {
    setFilteredUserId(userId);
    fetchReviews(userId);
  };

  const handleResetFilter = () => {
    setFilteredUserId(null);
    fetchReviews();
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
        <h2 className="text-success fs-2 ff-poppins m-0">User Reviews !!</h2>
        {filteredUserId && (
          <button className="btn btn-secondary" onClick={handleResetFilter}>
            Show All Reviews
          </button>
        )}
      </div>

      {loading ? (
        <p className="text-center">Loading reviews...</p>
      ) : reviews.length === 0 ? (
        <p className="text-center">No reviews found.</p>
      ) : (
        <div className="row mt-4">
          {reviews.map((item) => (
            <div className="col-md-6 col-lg-4 mb-4" key={item._id}>
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-black">{item.product_id?.name || 'N/A'}</h5>
                  <p className="card-text mb-1">
                    <strong>User:</strong>{' '}
                    <button
                      className="btn btn-link p-0"
                      onClick={() => handleUserClick(item.user_id._id)}
                      disabled={filteredUserId === item.user_id._id}
                    >
                      {item.user_id?.name || 'N/A'}
                    </button>
                  </p>
                  <p className="card-text mb-1">
                    <strong>Role:</strong> {item.user_id?.role || 'N/A'}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Rating:</strong> {item.rating}
                  </p>
                  <p className="card-text mb-2">
                    <strong>Review:</strong> {item.review}
                  </p>
                  {item.user_id?.profile_image?.url ? (
                    <img
                      src={item.user_id.profile_image.url}
                      alt="Profile"
                      className="rounded-circle mt-2"
                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                    />
                  ) : (
                    <p className="text-muted">No Profile Image</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewList;